import { render, staticRenderFns } from "./OntUpgrade.vue?vue&type=template&id=6234750f&"
import script from "./OntUpgrade.vue?vue&type=script&lang=js&"
export * from "./OntUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports